import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["readonly"]
const _hoisted_3 = ["readonly"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "lowTitle text-cyan" }
const _hoisted_6 = { class: "lowTitle text-cyan" }
const _hoisted_7 = ["readonly"]
const _hoisted_8 = { class: "lowTitle text-cyan" }
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { class: "lowTitle text-cyan" }
const _hoisted_11 = ["readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_bank_account_data = _resolveComponent("bank-account-data")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Modalità pagamento",
          text: "Modalità pagamento"
        })
      ]),
      (_ctx.readonly)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.modalitaPagamento) = $event)),
            readonly: _ctx.readonly
          }, null, 8, _hoisted_2)), [
            [_vModelText, _ctx.localValue.modalitaPagamento]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.modalitaPagamento) = $event)),
            readonly: _ctx.readonly
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalitaPagamentos, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item.name
              }, _toDisplayString(item.name), 9, _hoisted_4))
            }), 128))
          ], 8, _hoisted_3)), [
            [_vModelSelect, _ctx.localValue.modalitaPagamento]
          ])
    ]),
    (_ctx.details)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.details.methodType == 'WireTransfer')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Dati bancari",
                    text: "Dati bancari"
                  })
                ]),
                _createVNode(_component_bank_account_data, {
                  item: _ctx.localValue.bankAccountData,
                  readonly: _ctx.readonly
                }, null, 8, ["item", "readonly"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.details.methodType == 'Email')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Email",
                    text: "Email"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.paypalEmail) = $event)),
                  readonly: _ctx.readonly
                }, null, 8, _hoisted_7), [
                  [_vModelText, _ctx.localValue.paypalEmail]
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.details.methodType == 'Crypto')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Address",
                    text: "Address"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.cryptoAddress) = $event)),
                  readonly: _ctx.readonly
                }, null, 8, _hoisted_9), [
                  [_vModelText, _ctx.localValue.cryptoAddress]
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.details.methodType == 'CardNumber')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Numero carta",
                    text: "Numero carta"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.revolutNumber) = $event)),
                  readonly: _ctx.readonly
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.localValue.revolutNumber]
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}